/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { object, shape } from 'prop-types';
import {
    IconButton, Button, Dialog, DialogActions, DialogContent, DialogContentText,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import withStyles from '@material-ui/core/styles/withStyles';
import { ENUMS } from '../../../../../../components/Chatbot/static_data/enum';

const styles = ({ palette, breakpoints, typography }) => ({
    dialog: {
        alignItems: 'center',
        minHeight: 'calc(100% - 20px)',
        margin: '0 auto !important',
        padding: '0',
        '&:first-child': {
            padding: '0',
            margin: '0 !important',
        },
    },
    backdrop: {
        position: 'fixed',
        zIndex: 2,
    },
    container: {
        [breakpoints.down('sm')]: {
            margin: '0 auto !important',
            maxWidth: '500px',
        },
    },
    paper: {
        [breakpoints.down('md')]: {
            width: 'calc(100% - 5px)',
            margin: 0,
            zIndex: 9999,
        },
    },
    header: {
        paddingTop: '0.5rem',
        paddingBottom: '0',
        paddingRight: '1rem',
    },
    closeButton: {
        padding: 0,
        color: '#000',
    },
    body: {
        padding: '0',
    },
    link: {
        width: '100%',
    },
    errorMsg: {
        fontSize: '1.25rem',
        padding: '0.25rem 1rem 0',
        color: '#000',
        fontWeight: 600,
        textAlign: 'center',
    },
    otherCollection: {
        textAlign: 'center',
        color: '#000',
        fontWeight: 500,
        padding: '0 1rem 0.25rem',
    },
    footer: {
        padding: '1rem',
    },
    button: {
        borderRadius: '0 !important',
        fontSize: '1.25rem',
        fontWeight: typography?.font_weight_regular,
        backgroundColor: palette?.primaryButton,
        '&:hover': {
            backgroundColor: '#a4cf19',
            borderColor: '#9bc318',
        },
    },
});

const ShopNotAvailableModal = ({ classes, restrictedStates }) => {
    const [open, setOpen] = React.useState(true);
    return (
        <Dialog
            fullWidth
            maxWidth="md"
            open={open}
            classes={{
                container: classes.container,
                paper: classes.paper,
            }}
        >
            <DialogContent
                classes={{
                    root: classes.dialog,
                }}
            >
                <DialogActions
                    classes={{
                        root: classes.header,
                    }}
                >
                    <IconButton
                        size="small"
                        classes={{
                            root: classes.closeButton,
                        }}
                    >
                        <CloseIcon onClick={() => setOpen(false)} />
                    </IconButton>
                </DialogActions>
                <DialogContentText
                    classes={{
                        root: classes.errorMsg,
                    }}
                >
                    {ENUMS.CA_UNAVAILABE_ERROR_MSG}
                </DialogContentText>
                <DialogContentText
                    classes={{
                        root: classes.otherCollection,
                    }}
                >
                    {ENUMS.SHOP_OTHER_COLLECTION}
                </DialogContentText>
                <DialogActions
                    classes={{
                        root: classes.footer,
                    }}
                >
                    <Link to={restrictedStates?.collection_url} className={classes.link}>
                        <Button fullWidth className={classes.button}>
                            SHOP NOW
                        </Button>
                    </Link>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

ShopNotAvailableModal.propTypes = {
    classes: object,
    restrictedStates: object,
};

ShopNotAvailableModal.defaultProps = {
    classes: {},
    restrictedStates: shape({
        collection_url: '',
    }),
};

export default withStyles(styles)(ShopNotAvailableModal);
